// extracted by mini-css-extract-plugin
export default {"deptTreeSelectWrap":"src-pages-rule-pages-detail-components-AssignInfoSelector-module_deptTreeSelectWrap--KWA_d"};